module.exports = __webpack_public_path__ + "img/access_restriction.df304f2d.png";